import { useCallback, useEffect, useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';

import FullscreenProvider from 'features/fullscreen';

import { ExamsStartModal, useExams } from 'features/exams';
import { Flex, Loading } from 'components';
import { PrivateRoute } from 'app/routes';
import { ExamNavbar } from 'features/navbar';
import { useSchool } from 'features/school';
import { useSheets } from 'features/dashboard-new';
import { useBreakpoints } from 'app/hooks';

const ExamLayout = () => {
  const [loading, setLoading] = useState(true);

  const { examUuid } = useParams();

  const { getDashboardUi } = useSheets();

  const { fetchExam, clearExamsDetails, examsAction, setExamsQuestions } = useExams();
  const { schoolAlias } = useSchool();

  const breakpoint = useBreakpoints();

  const fetchCurrentExam = useCallback(async () => {
    setLoading(true);

    await fetchExam(examUuid, async (data) => {
      setExamsQuestions(
        Array(data.questionCount)
          .fill({
            order: 0,
            studentPracticeExamAssessmentQuestionUuid: null,
            studentPracticeExamAssessmentQuestionAnswerChoiceUuid: null,
            rightAnswer: null,
          })
          .map((question, index) => ({ ...question, order: index + 1 }))
      );

      setLoading(false);
    });
  }, [examUuid]);

  useEffect(() => {
    if (examUuid) fetchCurrentExam();

    return () => {
      clearExamsDetails();
    };
  }, [examUuid]);

  useEffect(() => {
    getDashboardUi();
  }, []);

  return (
    <>
      <PrivateRoute>
        {!!examUuid && examsAction === 'start' && <ExamsStartModal />}

        {loading ? (
          <Loading label="Por favor, aguarde." />
        ) : (
          <Flex className={`theme-${schoolAlias} theme-wrapper theme-wrapper-${breakpoint}`} minHeight="100vh" flexDirection="column">
            <FullscreenProvider display="flex" flexDirection="column">
              <Flex flexGrow={0}>
                <ExamNavbar />
              </Flex>

              <Flex as="main" flexWrap="nowrap" flexDirection="column">
                <Flex flexDirection="column" justifyContent="flex-start" bg="quizQuestionsBg">
                  <Outlet />
                </Flex>
              </Flex>
            </FullscreenProvider>
          </Flex>
        )}
      </PrivateRoute>
    </>
  );
};

export default ExamLayout;
